import { KeyboardEvent, useCallback } from 'react';

import { useNativeCharacterLimit } from './use-native-character-limit.hook';

interface UseTextboxCharacterLimitOptions {
  maxLength: number;
  onValueChange?: (value: string) => void;
  value: string;
}

export function useTextboxCharacterLimit({
  maxLength,
  onValueChange,
  value,
}: UseTextboxCharacterLimitOptions) {
  const handleValueChange = useCallback(
    (nextValue: string) => {
      onValueChange?.(nextValue);
    },
    [onValueChange],
  );

  const nativeCharacterLimit = useNativeCharacterLimit({
    maxLength,
    onValueChange: handleValueChange,
    value,
  });

  const onKeyDownPreventLineBreak = useCallback((event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }, []);

  return {
    ...nativeCharacterLimit,
    onKeyDownPreventLineBreak,
  };
}
